export const GAPTheme = {
	palette: {
		mode: 'light',
		primary: {
			main: '#331435',
			contrastText: '#fff',
		},
		primaryReversed: {
			main: '#fff',
			contrastText: '#331435',
		},
		secondary: {
			main: '#aae4ce',
			contrastText: '#331435',
		},
		info: {
			main: '#331435',
		},
		warning: {
			main: '#d84315',
		},
		white: {
			main: '#ffffff',
			contrastText: '#331435',
		},
	},
	typography: {
		fontFamily: 'DM Sans',
	},
	components: {
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					fontSize: '.875rem',
					fontWeight: 300,
					lineHeight: '125%',
				},
			},
		},
	},
};
